import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { editorTypes, MultiData } from 'src/app/constants/constants';
import { mathJaxCodes } from './mathjax-constants';

interface CreateMultiData {
  multiData: MultiData;
  error: boolean;
}

@Component({
  selector: 'app-create-multi-data',
  templateUrl: './create-multi-data.component.html',
  styleUrls: ['./create-multi-data.component.scss'],
})
export class CreateMultiDataComponent implements OnInit {
  @Input() createMultiData: CreateMultiData | undefined;
  @Output() toggleAccordion = new EventEmitter();
  @Output() confirmDelete = new EventEmitter();
  @Output() uploadImage = new EventEmitter();
  editorTypes = editorTypes;
  mathJaxCodes = mathJaxCodes;

  constructor() {}

  ngOnInit(): void {}

  confirmDeleteAction(index: number) {
    this.confirmDelete.emit(index);
  }

  toggleAccordionAction() {
    this.toggleAccordion.emit();
  }

  uploadFileAction(event: any, fileSelector: any) {
    this.uploadImage.emit({ event, fileSelector });
  }

  addMathjaxContent(
    textArea: HTMLTextAreaElement,
    firstString: string,
    secondString: string
  ): void {
    const start = textArea.selectionStart;
    const end = textArea.selectionEnd;

    // Combine the two strings
    const combinedText = firstString + secondString;

    // Insert the combined text at the cursor position
    if (this.createMultiData)
      this.createMultiData.multiData.data =
        this.createMultiData.multiData.data.slice(0, start) +
        combinedText +
        this.createMultiData.multiData.data.slice(end);

    // Calculate the new cursor position (middle of the inserted text)
    const newCursorPosition = start + firstString.length;

    // Update the cursor position
    setTimeout(() => {
      textArea.selectionStart = textArea.selectionEnd = newCursorPosition;
      textArea.focus();
    });
  }
}
